<span class="boletoFacil" style="position: fixed; left: 5px; z-index: 100; bottom: 5px; display: inline-block;">
	<a href="https://appimobiliariayara.com.br/yara/login?boleto-facil=1" target="_blank">
		<img src="assets/images/imgBoleto.png" alt="Boleto" style="border: 0px;" />
	</a>
</span>